import { motion, useInView } from "framer-motion";
import { useRef, useEffect, useState } from "react";
import { Star } from "lucide-react";

export const Testimonials = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "200px" });
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    // Only load Elfsight script when component is near viewport
    if (isInView && !scriptLoaded) {
      const script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      setScriptLoaded(true);

      return () => {
        const existingScript = document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]');
        if (existingScript) {
          existingScript.remove();
        }
      };
    }
  }, [isInView, scriptLoaded]);

  return (
    <section className="py-24 bg-gradient-dark noise-overlay">
      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-primary font-semibold tracking-wider uppercase text-sm">
            Customer Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6">
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center gap-3">
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-6 w-6 fill-primary text-primary" />
              ))}
            </div>
            <span className="text-2xl font-bold text-foreground">5.0</span>
          </div>
        </motion.div>

        {/* Elfsight Google Reviews Widget - Lazy loaded */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.2 }}
          className="flex justify-center min-h-[300px]"
        >
          {isInView && (
            <div 
              className="elfsight-app-77d6d449-b9c8-4e36-962d-c4a771cf017e" 
              data-elfsight-app-lazy
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};
